<script>import { getContext, onMount } from "svelte";
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = void 0;
export let contextKey;
const ctx = getContext(contextKey);
let { error, disabled, empty, focus, dirty, visited } = ctx;
const clearStoryClass = (classes, className) => {
  const i = classes.indexOf(className);
  if (i >= 0) {
    classes.splice(i, 1);
  }
  return i >= 0;
};
const storyClasses = (story ?? "filled").split(".");
disabled.set(clearStoryClass(storyClasses, "disabled") ? true : $disabled);
empty.set(clearStoryClass(storyClasses, "empty") ? true : $empty);
focus.set($disabled ? false : clearStoryClass(storyClasses, "focus") ? true : $focus);
dirty.set($disabled ? false : clearStoryClass(storyClasses, "dirty") ? true : $dirty);
visited.set($disabled ? false : clearStoryClass(storyClasses, "visited") ? true : $visited);
let inputFieldElem;
let hasLeadIcon = false;
onMount(async () => {
  const iconSpan = inputFieldElem.querySelector("div.control div.content span.lead");
  if (iconSpan) {
    const styles = window.getComputedStyle(iconSpan, "::before");
    const content = styles.content;
    hasLeadIcon = !!content && content.length > 2;
  }
});
</script>

<div
	bind:this={inputFieldElem}
	class="inputField {storyClasses.join(' ')} {hasLeadIcon ? 'icon' : ''}  {$error
		? 'error'
		: ''} {$empty ? 'empty' : ''} {$focus ? 'focus' : ''} {$dirty ? 'dirty' : ''} {$visited
		? 'visited'
		: ''} {$disabled ? 'disabled' : ''}"
>
	<div class="control">
		<fieldset role="presentation">
			<legend>{$empty && callToInput ? callToInput : label}</legend>
			<div class="content"><slot name="icon">
				<span class="lead" /></slot><span class="input"
					><slot name="input" /><span class="label"
						>{$empty && callToInput ? callToInput : label}</span
					></span
				>{#if $$slots.rest}<span class="rest"><slot name="rest" /></span>{/if}
			</div>
		</fieldset>
	</div>
	{#if $error}
		<span class="field-helper">{$error}</span>
	{:else if assistText}
		<span class="field-helper">{assistText}</span>
	{:else}
		<span class="field-helper">&nbsp;</span>
	{/if}
</div>

<style>
  .inputField {
    --input-font: 700 1.125rem/1.2 "Roboto";
    --input-font-size: 1.125rem;
    --input-line-height: 1.2;
    --input-letter-spacing: 0.0625rem;
    --label-font: 700 0.875rem/1.2 "Roboto";
    --label-font-size: 0.875rem;
    --label-line-height: 1.2;
    --label-letter-spacing: 0.0625rem;
    --assist-font: 700 0.875rem/1.2 "Roboto";
    --assist-font-size: 0.875rem;
    --assist-line-height: 1.2;
    --assist-letter-spacing: 0.0625rem;
    --input-text-margin-top: 0.4375rem;
    --input-text-margin-bottom: 0.625rem;
    --border-color: #46464A;
    --focus-color: #6BAE85;
    --border-radius: 0.25rem;
    --text-color: #DBE4E7;
    --error-color: #C2185B;
    --label-padding: 0.0625rem;
    --label-margin-top: 0.5625rem;
    --fill: #1A1B1F;
    --outline-width: 0.0625rem;
    --indicator-height: 0.125rem;
    --padding-left: 1rem;
    --assist-color: #DBE4E7;
    --disabled-text-color: #46464A;
    --item-spacing: 0.5rem;
    --lead-icon: '';
  }

  .filled {
    --border-color: #46464A;
    --disabled-text-color: #46464A;
  }

  .outlined {
    --border-color: #1A1B1F;
    --disabled-text-color: #1A1B1F;
  }

  .dateTime {
    --lead-icon: '\f073';
  }

	div.inputField {
		--control-top-padding: calc((var(--label-font-size) / 1.5) + var(--label-margin-top));
		--leading-icon-width: 0;
	}
	div.inputField.icon {
		--leading-icon-width: 1;
	}

	div.control {
		padding-top: var(--control-top-padding);
	}

	div.control fieldset div.content {
		display: flex;
		flex-flow: row nowrap;
		align-items: flex-end;
		align-content: center;
		height: 100%;
		width: 100%;
		padding: 0 var(--padding-left);
	}

	div.control fieldset div.content > * {
		margin-bottom: var(--input-text-margin-bottom);
		margin-top: var(--input-text-margin-top);
	}

	div.control fieldset div.content > span.lead {
		flex-grow: 0;
		flex-shrink: 0;
	}
	div.control fieldset div.content > span.input {
		flex-grow: 1;
		flex-shrink: 0;
		position: relative;
	}
	div.control fieldset div.content > span.rest {
		flex-grow: 0;
		flex-shrink: 0;
		position: relative;
	}
	div.control fieldset div.content > span.lead:before {
		content: var(--lead-icon);

		box-sizing: border-box;
		color: var(--text-color);
		font-size: var(--input-font-size);
		width: var(--input-font-size);
	}
	div.control fieldset div.content > span.lead:before {
		letter-spacing: var(--item-spacing);
		margin-right: 0.1px;
	}

	div.control fieldset div.content > span.input :global(input) {
		padding: 0;
		outline: none;
		border: 0;
		background-color: transparent;
		color: var(--text-color);
		font: var(--input-font);
		letter-spacing: var(--input-letter-spacing);
		line-height: 1.2;
		width: 100%;
	}
	div.control fieldset div.content > span.input :global(div.select) {
		color: var(--text-color);
		font: var(--input-font);
		letter-spacing: var(--input-letter-spacing);
		line-height: 1.2;
	}

	div.inputField div.control fieldset div.content > span.input span.label {
		white-space: nowrap;
		transition-property: all;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
		pointer-events: none;
	}
	/*label as place holder (when empty)*/
	div.inputField.empty div.control fieldset div.content > span.input span.label {
		position: absolute;
		top: 0;
		left: 0;

		color: var(--text-color);
		font: var(--input-font);
		letter-spacing: var(--input-letter-spacing);
		line-height: 1.2;
	}
	/*label floating (when not empty or focus)*/
	div.inputField.focus div.control fieldset div.content > span.input span.label,
	div.inputField:not(.empty) div.control fieldset div.content > span.input span.label {
		position: absolute;
		top: calc((-0.6 * var(--label-font-size)) - var(--input-text-margin-top));
		left: calc(
			(((-1 * var(--input-font-size)) - var(--item-spacing)) * var(--leading-icon-width)) +
				var(--label-padding) + (var(--leading-icon-width) * var(--label-padding))
		);

		color: var(--focus-color);
		font: var(--label-font);
		letter-spacing: var(--label-letter-spacing);
		line-height: 1;
	}

	div.inputField.filled div.control {
		border-top-right-radius: var(--border-radius);
		border-top-left-radius: var(--border-radius);
		background-color: var(--fill);
	}

	fieldset {
		width: 100%;
		display: inline-block;
		border-style: solid;
		border-color: var(--border-color);
		border-width: 0;
		border-bottom-width: var(--indicator-height);
		padding: 0;
		margin: 0;
	}
	div.inputField.outlined div.control fieldset {
		border-radius: var(--border-radius);
		border-width: var(--outline-width);
	}
	/* error style */
	div.inputField.error div.control fieldset {
		border-color: var(--error-color);
	}
	div.inputField.error div.control fieldset div.content > span.input span.label {
		color: var(--error-color);
	}

	/*disabled style */
	div.inputField.disabled div.control fieldset div.content > span.lead:before,
	div.inputField.disabled div.control fieldset div.content > span.input :global(input),
	div.inputField.disabled div.control fieldset div.content > span.rest :global(input),
	div.inputField.disabled div.control fieldset div.content > span.input span.label {
		color: var(--disabled-text-color);
	}
	div.inputField.disabled div.control fieldset {
		border-color: transparent;
	}
	div.inputField.disabled span.field-helper {
		color: transparent;
	}

	legend {
		margin-left: var(--padding-left);
		font: var(--label-font);
		line-height: 0;
		padding: 0 var(--label-padding);
		letter-spacing: var(--label-letter-spacing);
		color: transparent;
	}
	div.inputField.empty:not(.focus) div.control legend {
		font-size: 0em;
		float: left;
	}
	div.inputField.focus div.control fieldset {
		border-color: var(--focus-color);
	}
	div.inputField span.field-helper {
		font: var(--assist-font);
		color: var(--assist-color);
		padding-left: var(--padding-left);
	}

	div.content > span.lead:before {
		/* use !important to prevent issues with browser extensions that change fonts */
		font-family: 'tlmd-icons' !important;
		font-style: normal;
		font-weight: normal;
		font-variant: normal;
		text-transform: none;

		/* Enable Ligatures ================ */
		-webkit-font-feature-settings: 'liga';
		-moz-font-feature-settings: 'liga=1';
		-moz-font-feature-settings: 'liga';
		-ms-font-feature-settings: 'liga' 1;
		font-feature-settings: 'liga';
		-webkit-font-variant-ligatures: discretionary-ligatures;
		font-variant-ligatures: discretionary-ligatures;

		/* Better Font Rendering =========== */
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>
